<template>
  <div>
    <Modal :title="title" v-model="visible" width="1120px" :mask-closable="false" class="my-modal">
      <div class="img-list">
        <img :src="url" v-for="url in list" :key="url" @click="sel(url)" />
      </div>
    </Modal>
  </div>
</template>
<script>
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: {},
  props: {
    imgType: null
  },
  filters: {},
  data() {
    return {
      visible: false,
      list: [],
      title: '',
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {
    open() {
      this.visible = true;
      if (this.imgType == 1) {
        this.title = '选择底图-首图';
      } else if (this.imgType == 2) {
        this.title = '选择底图-常规图';
      }
      this.getList();
    },
    sel(url) {
      this.$emit('select', url);
      this.visible = false;
    },
    async randomImg(url) {
      await this.getList();
      const list = this.list.filter(item => item != url);
      if (list.length) {
        const num = Math.floor(Math.random() * list.length);
        this.sel(list[num]);
      }
    },
    // 获取图片列表系统参数
    getList() {
      return this.$http({
        url: '/system/sysParams/getValue',
        type: 'get',
        data: {
          key: this.imgType == '1' ? 'sell_card_img_library_first' : 'sell_card_img_library'
        }
      }).then(res => {
        this.list = res.data.split(',');
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.img-list {
  padding-top: 20px;
  img {
    margin-right: 20px;
    margin-bottom: 20px;
    width: 335px;
    cursor: pointer;
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}
</style>






